'use client';
import styles from '../style.module.scss';
import React, { useEffect, useMemo, useState } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { calculateTimeRemaining } from '@/app/helpers/fomofeatures';

type Props = {
  endTime: string;
  isDetail?: boolean;
  trackingData?: object | null;
};

const CouponCountDownLabel = ({ endTime, isDetail }: Props) => {
  const { t } = useTranslation('COMMON');
  // Precompute initial time remaining
  const initialTimeRemaining = useMemo(() => calculateTimeRemaining(endTime), [endTime]);
  const [timeRemaining, setTimeRemaining] = useState(initialTimeRemaining);

  useEffect(() => {
    let animationFrame: number;

    const updateTimer = () => {
      const remainingTime = calculateTimeRemaining(endTime);
      if (remainingTime !== timeRemaining) {
        setTimeRemaining(remainingTime);
      }
      if (remainingTime) {
        animationFrame = requestAnimationFrame(updateTimer);
      }
    };

    updateTimer();

    return () => cancelAnimationFrame(animationFrame); // Clean up on unmount
  }, [endTime, timeRemaining]);
  if (!timeRemaining) return null;

  return (
    <>
      <div className={styles[isDetail ? 'countDownPDP' : 'countDownLabel']}>
        <span>
          <Image
            src={`/intstatic/icons/clock-icon.svg`}
            style={{ marginRight: '0.25rem', marginBottom: '0.1rem' }}
            alt={'Clock Icon'}
            width={12}
            height={12}
          />
          {t('ENDS_IN')} {timeRemaining}
        </span>
      </div>
    </>
  );
};

export default CouponCountDownLabel;
